// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1DayPropertySchema } from './v1/dayPropertySchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listUserDayPropertiesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  user_id: z.number().int().describe("User ID"),
});

export const listUserDayPropertiesQueryParamsSchema = z.object({
  since: z.optional(z.string().date().describe("Start date for filtering (YYYY-MM-DD)")),
  until: z.optional(z.string().date().describe("End date for filtering (YYYY-MM-DD)")),
}).optional();

export const listUserDayPropertiesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description User day properties retrieved successfully
 */
export const listUserDayProperties200Schema = z.array(z.lazy(() => v1DayPropertySchema));

/**
 * @description Unauthorized
 */
export const listUserDayProperties401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listUserDayPropertiesQueryResponseSchema = z.lazy(() => listUserDayProperties200Schema);
